import { Service } from '@roc/feature-app-core';

const url = {
  CREATE_DRAW: '/api/v1/draws/createDraw',
  SWITCH_FREEZE_FUNDING: '/api/v1/draws/switchFreezeFunding',
  GET_FREEZE_FUNDING_STATUS: '/api/v1/draws/getFreezeFundingStatus',
  APPROVE_SOWS: '/api/v1/draws/approveSOW',
  ORDER_INSPECTION: '/api/v1/draws/orderInspection',
  APPROVE_INSPECTION: '/api/v1/draws/approveInspections',
  VERIFY_WIRE_DETAILS: '/api/v1/draws/verifyWireDetails',
  APPROVE_WIRE: '/api/v1/draws/approveWire',
  RESOLVE_DRAW: '/api/v1/draws/resolveDraw',
  REJECT_DRAW: '/api/v1/draws/rejectDrawRevision',
  SET_DRAW_STAGE: '/api/v1/draws/setDrawStage',
  GET_TRANSACTION_GRID_BY_LOAN_ID: '/api/v1/loan/getTransactions',
  LINK_TRANSACTION_ID_TO_DRAW: '/api/v1/draws/linkTransactionIdToDraw',
  GET_ALL_SNAP_DRAWS: '/api/v1/draws/getAllSnapDraws',
  GET_IF_INSPECTION_OPEN: '/api/v1/draws/getIfInspectionOpen',
  MOVE_TRUEPIC_PICTURES_TO_DRAW: '/api/v1/draws/moveTruepicPicturesToDraw',
  APPROVE_REVISION: '/api/v1/draws/approveRevision',
};

export class DrawActionsService extends Service {

  createDraw(data) {
    return this.post(`${url.CREATE_DRAW}`, data);
  }

  getFreezeFundingStatus(loanId) {
    return this.get(`${url.GET_FREEZE_FUNDING_STATUS}?loanId=${loanId}`);
  }

  switchFreezeFunding(loanId) {
    return this.put(`${url.SWITCH_FREEZE_FUNDING}?loanId=${loanId}`, {});
  }

  approveSOW(drawId) {
    return this.put(`${url.APPROVE_SOWS}?drawId=${drawId}`, {});
  }

  orderInspection(drawId, option) {
    return this.put(`${url.ORDER_INSPECTION}?drawId=${drawId}&inspectionCompany=${option}`, {});
  }

  approveInspections(drawId) {
    return this.put(`${url.APPROVE_INSPECTION}?drawId=${drawId}`, {});
  }

  verifyWireDetails(drawId, verification) {
    return this.post(`${url.VERIFY_WIRE_DETAILS}?drawId=${drawId}&verification=${verification}`, {});
  }

  approveWire(drawId) {
    return this.put(`${url.APPROVE_WIRE}?drawId=${drawId}`, {});
  }

  resolveDraw(drawId) {
    return this.put(`${url.RESOLVE_DRAW}?drawId=${drawId}`, {});
  }

  rejectSOWrevision(drawId, rejectionReason) {
    return this.post(`${url.REJECT_DRAW}?drawId=${drawId}`, rejectionReason, {
      'Content-Type': 'application/json',
    });
  }

  setDrawStage(drawId, drawStage) {
    return this.put(`${url.SET_DRAW_STAGE}?drawId=${drawId}&drawStage=${drawStage}`, {});
  }

  getTransactionGridByLoanId(loanId) {
    return this.get(`${url.GET_TRANSACTION_GRID_BY_LOAN_ID}?loanId=${loanId}`);
  }

  linkTransactionIdToDraw(drawId, transactionId) {
    return this.put(`${url.LINK_TRANSACTION_ID_TO_DRAW}?drawId=${drawId}&transactionId=${transactionId}`, {});
  }

  moveTruepicPicturesToDraw(drawId, event) {
    return this.post(`${url.MOVE_TRUEPIC_PICTURES_TO_DRAW}?drawId=${drawId}`, event);
  }

  getSnapDrawsEvents() {
    return this.get(`${url.GET_ALL_SNAP_DRAWS}`);
  }

  getIfInspectionOpen(drawId) {
    return this.get(`${url.GET_IF_INSPECTION_OPEN}?drawId=${drawId}`);
  }

  approveRevision(drawId) {
    return this.put(`${url.APPROVE_REVISION}?drawId=${drawId}`, {});
  }

}